export default {"src":"/a/r/be1.10/_next/static/media/delete-circle.3204a0b6.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};